import styled from 'styled-components'
import TopnavLogo from './TopnavLogo'
import TopnavLink from './TopnavLink'
import RouteContainer from '../styles/RouteContainer'
import useUrl from '../hooks/useUrl'
import {Nav, Navbar} from 'react-bootstrap'
import TopnavUserIcon from './TopnavUserIcon'
import ColorConfig from '../../config/ColorConfig'
import useLoginStore from '../../routes/login/useLoginStore'
import booksitoutIcon from '../../config/BooksitoutIcon'
import {useDarkMode} from '../hooks/DarkModeContext'
import Spacer from "../Spacer";

const Topnav = () => {
    const urls = useUrl()
    const isLoggedIn = useLoginStore(state => state.isLoggedIn())

    const {isDark, toggleTheme} = useDarkMode()

    let bookUrl = '/book/mine?range=READING';

    let isBookActive = urls.startsWith('/book');
    let isLibraryActive = urls.startsWith('/library');
    let isCommunityActive = urls.startsWith('/community');

    let darkModeIcon = <booksitoutIcon.darkMode className="text-book dark"
                                                style={{fontSize: '25px', marginTop: '2px'}}/>;

    let lightModeIcon = <booksitoutIcon.lightMode className="text-book light"
                                                  style={{fontSize: '25px', marginTop: '2px'}}/>;

    return (
        <TopnavContainer>
            <RouteContainer>
                <Container>
                    <TopnavLogo/>

                    <LogoSpacer/>

                    <div className={'d-flex w-100'}>
                        <div className={'d-flex'} style={{paddingTop: '9px'}}>
                            <TopnavLink label={'서재'} url={bookUrl} isActive={isBookActive}/>
                            <TopnavLink label={'도서관'} url={'/library'} isActive={isLibraryActive}/>
                            <TopnavLink label={'커뮤니티'} url={'/community'} isActive={isCommunityActive}/>
                        </div>

                        <Spacer/>

                        <TopnavUserIconContainer>
                            <CheckedStyles>
                                <ToggleContainer>
                                    <ToggleInput checked={isDark} onChange={toggleTheme}/>
                                    {isDark ? darkModeIcon : lightModeIcon}
                                </ToggleContainer>
                            </CheckedStyles>

                            <TopnavUserIcon/>
                        </TopnavUserIconContainer>
                    </div>

                </Container>
            </RouteContainer>
        </TopnavContainer>
    )
}

const TopnavContainer = styled(Navbar)`
    position: sticky;
    //top: env(safe-area-inset-top, 0);
    top: 0;
    z-index: 2000;
    border-bottom: 1px solid #e0e0e0;
    padding: 0;
    //margin-top: calc(-1 * env(safe-area-inset-top, 0));
`

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    padding-top: 5px;
    padding-bottom: 5px;
`

const LogoSpacer = styled.div`
    padding-left: 20px;
`

const TopnavUserIconContainer = styled(Nav)`
    a.dropdown-toggle.nav-link::after {
        color: ${ColorConfig.Primary};
    }
`

const ToggleContainer = styled.label`
    display: inline-flex;
    margin-top: 8px;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    position: relative;
`

const ToggleInput = styled.input.attrs({type: 'checkbox', className: 'form-check-input'})`
    position: absolute;
    opacity: 0;
    inset: 0;
    margin: 0;
    cursor: pointer;
`

const ToggleRoundedPill = styled.span`
    position: relative;
    width: 50px;
    height: 26px;
    background: #1cb15a77;
    padding: 3px;
    border-radius: 50px;
    transition: background 0.25s;
`
const ToggleIcon = styled.span`
    position: absolute;
    background-color: white;
    width: 20px;
    height: 20px;
    left: 3px;
    top: 3px;
    transition: transform 0.25s;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    border-radius: 99px;
    display: grid;
    place-items: center;

    .light, .dark {
        position: absolute;
        font-size: 16px;
        line-height: 1;
        transition: opacity 0.2s;
    }

    .light {
        opacity: 1;
    }

    .dark {
        opacity: 0;
    }
`

const CheckedStyles = styled.div`
    ${ToggleInput}:checked + ${ToggleRoundedPill} {
        background: #1cb15a;
    }

    ${ToggleInput}:checked + ${ToggleRoundedPill} ${ToggleIcon} {
        transform: translateX(26px);
    }

    ${ToggleInput}:checked + ${ToggleRoundedPill} ${ToggleIcon} .light {
        opacity: 0;
    }

    ${ToggleInput}:checked + ${ToggleRoundedPill} ${ToggleIcon} .dark {
        opacity: 1;
    }
`

export default Topnav
